import routesPathLottery from './routesPathLottery';
import routesPathWallet from './routesPathWallet';

const getRouterDailyReport = () => {
    let r = [
        '/daily_report/ion',
        '/daily_report/spade',
        '/daily_report/habanero',
        '/daily_report/pragmatic',
        '/daily_report/pragmaticplaylive',
        '/daily_report/joker',
        '/daily_report/cq9',
        '/daily_report/pgsoft',
        '/daily_report/liteplay',
        '/daily_report/microgaming',
        '/daily_report/SexyBaccarat',
        '/daily_report/VirtualSports',
        '/daily_report/SBOGames',
        '/daily_report/SBOLiveCasino',
        '/daily_report/SBOSportsBook',
        '/daily_report/sbolivecasinobeauty',
        '/daily_report/sbosportsp2p',
        '/daily_report/saba',
        '/daily_report/idnlive',
        '/daily_report/ttg',
        '/daily_report/allbet',
        '/daily_report/advantplay',
        '/daily_report/skywind',
        '/daily_report/rich88',
        '/daily_report/fachai',
        '/daily_report/nolimitcity',
        '/daily_report/spinix',
        '/daily_report/nagagames',
        '/daily_report/marioclub',
        '/daily_report/mimigaming',
    ];

    if (window.appName === 'lottery') {
        r = [...r, '/daily_report/we'];
    } else {
        r = [...r, '/daily_report/ksgaming'];
    }
    return r;
};

export const getRouterPath = (currentUser, i18nn) => {
    const rDailyReport = getRouterDailyReport();
    if (window.appName === 'lottery') {
        return routesPathLottery(currentUser, i18nn, rDailyReport);
    }

    return routesPathWallet(currentUser, i18nn, rDailyReport);
};
